import { Navigate, Routes as RRDRoutes, Route } from "react-router-dom";
import { UpdatePassword } from "../components/UpdatePassword";
import AdminTechpack from "../containers/Admin/AdminTechpack";
import { Cart } from "../containers/Cart";
import CollectSizes from "../containers/CollectSizeContainer";
import Project from "../containers/Project/Project";
import Home from "../containers/HomeContainer/Home";
import { OnboardingContainer } from "../containers/OnboardingContainer";
import { UserOrderList } from "../containers/UserOrders";
import Team from "../containers/Team/Team";
import { Sizes } from "../containers/SizeContainer";
import PurchasedDesignStudioContainer from "../containers/StudioContainer/PurchasedDesignStudio/PurchasedDesignStudio";
import { StudioContainer } from "../containers/StudioContainer/StudioContainer";
import { ROUTES } from "../constant/common.constant";
import LocalizedComponent from "./LocalizedComponent";

import { ErrorFallback } from "../common/components/ErrorFallback/ErrorFallback";
import { ResetPassword } from "../components/Onboarding/ResetPassword";
import AdminOrderContainer from "../containers/Admin/AdminOrderContainer";
import { CartOverview } from "../containers/Cart/CartOverview";
import { CollectSizeSuccess } from "../containers/CollectSizeContainer/CollectSizeSuccess";
import { JoinTeamWithTokenContainer } from "../containers/JoinTeam";
import { UserInfo } from "../types";
import { useThemeBreakpoints } from "../utils/themeUtils";
import { PrivateRoutes } from "./PrivateRoutes";
import DistributorList from "../components/DistributorList/DistributorList";
import { AdminUserRoleList } from "../components/AdminUserRoleList";
import CartCheckout from "../containers/Cart/CartCheckout/CartCheckout";
import { Admin } from "../containers/Admin";
import AdminOrderListContainer from "../containers/Admin/AdminOrderListContainer";
import { AppContainer } from "../common/components";
import { UserProfile } from "../containers/UserProfile";
import UserOrder from "../containers/UserOrders/UserOrder";
import OrderProvider from "../context/Order/OrderProvider";
import Templates from "../containers/Templates/Templates";
import SpecsEditor from "../containers/SpecsEditor/SpecsEditor";
import FamiliesEditorPage from "../containers/SpecsEditor/FamiliesEditor/FamiliesEditorPage";
import FabricsEditorPage from "../containers/SpecsEditor/FabricsEditor/FabricsEditorPage";
import DecorationsEditorPage from "../containers/SpecsEditor/DecorationsEditor/DecorationsEditorPage";
import { useSelector } from "../common/hooks/useSelector";
import SpecsPreviewStudioContainer from "../containers/StudioContainer/SpecsPreviewStudio/SpecsPreviewStudio";
import { isProd } from "../utils/env";

// handle route that ere admin only

const Routes = () => {
  const currentUser = useSelector((state) => state.userInfo) as UserInfo;
  const { isMobile } = useThemeBreakpoints();

  return (
    <RRDRoutes>
      <Route path="/" element={<PrivateRoutes wrappedByAppContainer />}>
        <Route path={ROUTES.HOME} Component={Home} />
        <Route path={ROUTES.TEMPLATES} Component={Templates} />
        <Route
          path={ROUTES.SPECS_FAMILIES}
          element={
            currentUser?.isAdmin ? (
              <FamiliesEditorPage />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        />
        <Route
          path={ROUTES.SPECS_FABRICS}
          element={
            !isProd && currentUser?.isAdmin ? (
              <FabricsEditorPage />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        />
        <Route
          path={ROUTES.SPECS_DECORATIONS}
          element={
            !isProd && currentUser?.isAdmin ? (
              <DecorationsEditorPage />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        />
        <Route
          path={ROUTES.SPECS_GENERATOR}
          element={
            !isProd && (currentUser?.isAdmin || currentUser?.isDesigner) ? (
              <SpecsEditor />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        />
        <Route
          path={`${ROUTES.SPECS_GENERATOR}/:productName`}
          element={
            !isProd && (currentUser?.isAdmin || currentUser?.isDesigner) ? (
              <SpecsEditor />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        />
        <Route
          path={`${ROUTES.SPECS_GENERATOR}/:productName/:version`}
          element={
            !isProd && (currentUser?.isAdmin || currentUser?.isDesigner) ? (
              <SpecsEditor />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        />

        {/** Only for admin designers that are editing an already purchased design */}

        <Route path={ROUTES.JOIN} Component={JoinTeamWithTokenContainer} />

        <Route path={ROUTES.TEAM} Component={Team}>
          <Route path={ROUTES.PROJECT} Component={Project}>
            <Route path={ROUTES.STUDIO} Component={StudioContainer} />
          </Route>
        </Route>

        <Route path={ROUTES.SIZES} Component={Sizes} />

        <Route path={ROUTES.ORDERS} Component={UserOrderList} />
        <Route path={ROUTES.ORDERS_SUCCESS} Component={UserOrderList} />
        <Route path={ROUTES.USER_PROFILE} Component={UserProfile} />
      </Route>

      <Route path="/" element={<PrivateRoutes />}>
        <Route
          path={ROUTES.SPECS_STUDIO_PREVIEW}
          element={
            currentUser?.isAdmin ? (
              <SpecsPreviewStudioContainer />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        />
        <Route
          path={ROUTES.ADMIN}
          element={
            currentUser?.isAdmin || currentUser?.isDesigner ? (
              <Admin />
            ) : (
              <Navigate to={ROUTES.HOME} replace />
            )
          }
        >
          <Route
            path={ROUTES.ADMIN_STUDIO_PURCHASED_DESIGN}
            Component={PurchasedDesignStudioContainer}
          />
          <Route
            path={ROUTES.ADMIN_DISTRIBUTORS}
            Component={() => (
              <AppContainer>
                <DistributorList />
              </AppContainer>
            )}
          />
          <Route
            path={ROUTES.ADMIN_USERS}
            element={
              currentUser?.isAdmin ? (
                <AppContainer>
                  <AdminUserRoleList />
                </AppContainer>
              ) : (
                <Navigate to={ROUTES.HOME} replace />
              )
            }
          />
          <Route path={ROUTES.ADMIN_TECHPACK_ORDER} Component={AdminTechpack} />
          <Route path={ROUTES.ADMIN_ORDER} Component={AdminOrderContainer} />
          <Route
            path={ROUTES.ADMIN_ALL_ORDERS}
            Component={() => (
              <AppContainer>
                <AdminOrderListContainer />
              </AppContainer>
            )}
          />
        </Route>
      </Route>

      <Route
        path="/"
        element={<PrivateRoutes wrappedByAppContainer={isMobile} />}
      >
        <Route path={ROUTES.CART} Component={Cart}>
          <Route path={ROUTES.CART} Component={CartOverview} />
          <Route path={ROUTES.CHECKOUT} Component={CartCheckout} />
        </Route>
      </Route>

      <Route path="/" element={<PrivateRoutes />}>
        <Route
          path={ROUTES.ORDER}
          Component={() => (
            <OrderProvider>
              <UserOrder />
            </OrderProvider>
          )}
        />
      </Route>
      {/**
       * It's very important that the routes with tokens are created BEFORE the routes with token, or else they won't be used
       * For example, here we created route LOGIN_WITH_TOKEN before the route for LOGIN. If we would have done reverse, the route
       * with token would not have been used and the token prop would always be set to undefined in the component.
       */}
      {/* Login */}
      <Route path={ROUTES.LOGIN_WITH_TOKEN} Component={OnboardingContainer} />
      <Route path={ROUTES.LOGIN} Component={OnboardingContainer} />

      <Route
        path={`/fr/${normalizePath(ROUTES.LOGIN_WITH_TOKEN)}`}
        Component={(props) => (
          <LocalizedComponent
            language="fr"
            component={OnboardingContainer}
            {...props}
          />
        )}
      />
      <Route
        path={`/en/${normalizePath(ROUTES.LOGIN_WITH_TOKEN)}`}
        Component={(props) => (
          <LocalizedComponent
            language="en"
            component={OnboardingContainer}
            {...props}
          />
        )}
      />

      <Route
        path={`/fr/${normalizePath(ROUTES.LOGIN)}`}
        Component={() => (
          <LocalizedComponent language="fr" component={OnboardingContainer} />
        )}
      />
      <Route
        path={`/en/${normalizePath(ROUTES.LOGIN)}`}
        Component={() => (
          <LocalizedComponent language="en" component={OnboardingContainer} />
        )}
      />

      {/* Sign up (see comments above about token routes) */}

      <Route path={ROUTES.SIGN_UP_WITH_TOKEN} Component={OnboardingContainer} />
      <Route
        path={`/fr/${normalizePath(ROUTES.SIGN_UP_WITH_TOKEN)}`}
        Component={(props) => (
          <LocalizedComponent
            language="fr"
            component={OnboardingContainer}
            {...props}
          />
        )}
      />
      <Route
        path={`/en/${normalizePath(ROUTES.SIGN_UP_WITH_TOKEN)}`}
        Component={(props) => (
          <LocalizedComponent
            language="en"
            component={OnboardingContainer}
            {...props}
          />
        )}
      />

      <Route path={ROUTES.SIGN_UP} Component={OnboardingContainer} />
      <Route
        path={`/fr/${normalizePath(ROUTES.SIGN_UP)}`}
        Component={(props) => (
          <LocalizedComponent
            language="fr"
            component={OnboardingContainer}
            {...props}
          />
        )}
      />
      <Route
        path={`/en/${normalizePath(ROUTES.SIGN_UP)}`}
        Component={(props) => (
          <LocalizedComponent
            language="en"
            component={OnboardingContainer}
            {...props}
          />
        )}
      />

      {/* Reset Password */}
      <Route path={ROUTES.RESET_PASSWORD} Component={ResetPassword} />
      <Route
        path={`/fr/${normalizePath(ROUTES.RESET_PASSWORD)}`}
        Component={() => (
          <LocalizedComponent language="fr" component={ResetPassword} />
        )}
      />
      <Route
        path={`/en/${normalizePath(ROUTES.RESET_PASSWORD)}`}
        Component={() => (
          <LocalizedComponent language="en" component={ResetPassword} />
        )}
      />

      <Route
        path={ROUTES.UPDATE_PASSWORD}
        Component={() => <UpdatePassword />}
      />

      {/* Collect sizes */}
      <Route
        path={ROUTES.COLLECT_SIZE_SUCCESS}
        Component={() => <CollectSizeSuccess />}
      />

      <Route path={ROUTES.COLLECT_SIZE} Component={() => <CollectSizes />} />

      <Route path={ROUTES.ERROR} element={<ErrorFallback />} />

      {/* Special hack here to forward the search query parameters (see https://github.com/remix-run/react-router/issues/5818) */}
      <Route
        path="/*"
        Component={(props) => (
          <Navigate
            to={{
              ...props,
              pathname: ROUTES.HOME,
            }}
          />
        )}
      />
    </RRDRoutes>
  );
};

/**
 * @param {string} path
 */
function normalizePath(path: string) {
  if (path.startsWith("/")) return path.substr(1, path.length);

  return path;
}

export default Routes;
